// extracted by mini-css-extract-plugin
module.exports = {"swiperContainer":"ImageSlider_swiperContainer__1YdLI","swiperSlide":"ImageSlider_swiperSlide__BIf_k"};